module.exports = __webpack_public_path__ + "static/media/667.3e20a313.webp";